import PrepackageCalendar from './components/PrepackageCalendar.vue'
import TourInclude from './components/TourInclude.vue'
import TravelDates from './components/TravelDates.vue'

new Vue({
	el: '#package_tabbed',
	data: {
		tab: 'package',
		tourPreview: false,
		cityOpen: Project.departureCamel
	},
	components: { PrepackageCalendar, TourInclude, TravelDates },

})
